import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/fi/bars";

export const Route = createFileRoute("/fi/bars/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("bars")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "fi",
      loaderData,
      fallbackTitle: 'Baarit Suomessa — cocktailit ja viinit | what Finland',
      fallbackDescription: 'Suomalaiset baarit, viinibaarit ja cocktailhuoneet alueittain.',
      listName: 'Baarit Suomessa',
    }),
  component: () => <HubIndexPage slug="bars" locale="fi" />,
});
